import { render, staticRenderFns } from "./SnomedCodingPanel.vue?vue&type=template&id=67c0c5b0&scoped=true&lang=pug"
import script from "./SnomedCodingPanel.vue?vue&type=script&lang=js"
export * from "./SnomedCodingPanel.vue?vue&type=script&lang=js"
import style0 from "./SnomedCodingPanel.vue?vue&type=style&index=0&id=67c0c5b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0c5b0",
  null
  
)

export default component.exports